"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderHeader = void 0;
const common_1 = require("../../common");
const models_1 = require("../../partners/models");
const enums_1 = require("../enums");
const sales_order_file_model_1 = require("./sales-order-file.model");
const sales_order_line_model_1 = require("./sales-order-line.model");
class SalesOrderHeader extends common_1.MongoDocument {
    get extendedTotal() {
        return this.lines
            .map(line => typeof line === 'string' || line === undefined || line.quantity == undefined
            ? undefined
            : line.quantity * line.price)
            .reduce((total, num) => (num !== undefined && total !== undefined ? total + num : undefined), 0);
    }
}
exports.SalesOrderHeader = SalesOrderHeader;
//# sourceMappingURL=sales-order-header.model.js.map